// extracted by mini-css-extract-plugin
module.exports = {"globalPreFooter":"GlobalWrapper_globalPreFooter__QOZtT"};